module.exports = __webpack_public_path__ + "img/home-arguments-parallax.a69277c8.jpg";